import type { IFilter } from '../models/IFilter.ts';

export const linkService = {
  openLink(url: string) {
    window.location.href = url;
  },

  openWorkLogWithFilters(filters: IFilter[], url: string) {
    sessionStorage.setItem('DevExpressFilters', JSON.stringify(filters));
    window.location.href = url + `?returnUrl=${window.location.href}`;
  },
  openLinkWithParamFilters(
    filters: {
      parametr: string;
      value: number | string;
    }[],
    url: string
  ) {
    window.location.href =
      `${url}?` + filters.map((filter) => `${filter.parametr}=${filter.value}`).join('&');
  },
};
